import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Order } from "../../../types/api/Order";

import { Divider, Paper } from "@mui/material";
import LineItem from "../../store/components/line-item/LineItem";
import GenieText from "../../../components/core/genie-text/GenieText";
import { formatCurrency } from "../../../utils/currency";
import { readableDateTime } from "../../../utils/date";

interface Props {
  order: Order | null;
  open: boolean;
  setClosed: () => void;
}

export default function ViewOrderDialog({ open, order, setClosed }: Props) {
  const handleClose = () => {
    setClosed();
  };

  if (!order) {
    return null;
  }

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Order on {readableDateTime(order.completed_on)}</DialogTitle>
      <DialogContent>
        <Divider sx={{ my: 2 }} />
        {order.cart.line_items.map((lineItem) => (
          <LineItem
            cart={order.cart}
            readonly={true}
            lineItem={lineItem}
            key={lineItem.id}
          />
        ))}
        <div style={{ margin: "16px 0 0 0" }}>
          <GenieText fontSize="tiny" fontWeight="bold">
            Subtotal: {formatCurrency(order.cart.total_cents)}
          </GenieText>
        </div>
        <div style={{ margin: "2px 0" }}>
          <GenieText fontSize="tiny" fontWeight="bold">
            Shipping: {formatCurrency(order.shipping_cost_in_cents || 0)}
          </GenieText>
        </div>
        <div style={{ margin: "2px 0" }}>
          <GenieText fontSize="tiny" fontWeight="bold">
            Total:{" "}
            {formatCurrency(
              (order.shipping_cost_in_cents || 0) + order.cart.total_cents
            )}
          </GenieText>
        </div>
        <Divider sx={{ my: 2 }} />
        {order.shipping_address && (
          <Paper variant="outlined" sx={{ p: 2 }}>
            <GenieText fontSize={"tiny"} fontWeight={"bold"}>
              Ship to:
            </GenieText>
            <GenieText fontSize={"tiny"}>
              {order.created_by_user.name}
            </GenieText>
            <GenieText fontSize={"tiny"}>
              {order.shipping_address.line1}
            </GenieText>
            <GenieText fontSize={"tiny"}>
              {order.shipping_address.line2}
            </GenieText>
            <GenieText fontSize={"tiny"}>
              {order.shipping_address.city}, {order.shipping_address.state}{" "}
              {order.shipping_address.postal_code}
            </GenieText>
          </Paper>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Back</Button>
      </DialogActions>
    </Dialog>
  );
}
